module.exports = __webpack_public_path__ + "img/logo10.f67551ec.png";